import { render } from "./userProfile.vue?vue&type=template&id=31ecd852&ts=true"
import script from "./userProfile.vue?vue&type=script&lang=ts"
export * from "./userProfile.vue?vue&type=script&lang=ts"

import "./userProfile.vue?vue&type=style&index=0&id=31ecd852&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__